<template>
  <div class="item display-flex">
    <div class="item__img">
      <!-- <img class="inner-img" v-lazy="dataSource.imageUrl !== null ? replaceLink(dataSource.imageUrl) : ''" :alt="dataSource.name" /> -->
      <img class="inner-img" v-lazy="dataSource && dataSource.imageUrl !== null ? replaceLink(dataSource.imageUrl) : ''" :alt="dataSource && dataSource.name ? dataSource.name : ''" />
    </div>
    <div class="item__body">
      <div class="item__content">
        <h4 class="item__title font-size-16 primary-color-txt font-sanpro-semibold">{{ dataSource && dataSource.name ? dataSource.name : '' }}</h4>
        <span class="item__publish font-size-14 secondary-color-txt">Xuất bản: {{ dataSource && dataSource.manufactureYear ? dataSource.manufactureYear : '' }}</span>
      </div>
      <div class="item__action">
        <a 
          v-if="authInfo && authInfo.email === emailPublic"
          href="javascript:;"
          class="btn btn-main-light text-center border-rd-20 font-size-15 font-sanpro-semibold" 
          style="padding: 0 20px;line-height: 30px;"
          @click="setToggleLoginForm(true)"
        >Kích hoạt</a>
        <template v-else>
          <!-- <button type="button" class="btn btn-gray btn-pointer-evt-none css-atvd font-size-16 border-rd-20 secondary-color-txt font-sanpro-medium actived" v-if="dataSource.actived">
            <img src="@/assets/images/active-2.png" alt="Đã kích hoạt"> 
            Đã kích hoạt
          </button> -->
          <a
            v-if="dataSource && dataSource.actived"
            href="javascript:;"
            class="btn btn-warning border-rd-20 font-size-15 font-sanpro-semibold line-height-1-2"
            @click="handleDeactiveBook(dataSource)"
          >
            Hủy kích hoạt
          </a>
          <a 
            v-else-if="dataSource"
            href="javascript:;"
            class="btn btn-main-light text-center border-rd-20 font-size-15 font-sanpro-semibold" 
            style="padding: 0 20px;line-height: 30px;"
            @click="handleActiveBook(dataSource)"
          >
            Kích hoạt
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { APP_CONFIG } from '@/utils/constants'
  const img404 = require(`@/assets/images/img_404.jpg`)
  import { getAuth } from '@/utils/jwt'
  import { EMAIL_PUBLIC } from '@/store/auth/constants'
  import { replaceImageResize } from '@/helpers/functions'

  export default {
    name: 'ItemBookActive',
    props: {
      dataSource: Object
    },
    data () {
      return {
        urlImg: APP_CONFIG.urlQuestionImg,
        img404,
        authInfo: {},
        emailPublic: EMAIL_PUBLIC
      }
    },
    computed: {
      ...mapState('auth', ['loginPopupData'])
    },
    created() {
      this.authInfo = getAuth();
    },
    watch: {
      loginPopupData(newVal) {
        if(newVal && Object.keys(newVal).length) {
          this.authInfo = newVal;
        }
      }
    },
    methods: {
      ...mapActions('auth', ['setToggleLoginForm']),
      handleActiveBook (val) {
        this.$emit('active', val)
      },
      handleDeactiveBook (book) {
        if (!book || !book.bookId || !book.esStampId) {
          return
        }
        this.$emit('deactive', book)
      },
      replaceLink (link) {
				return replaceImageResize(link, {width: 285, height: 404})
			}
    }
  }
</script>

<style lang="scss" scoped>
  .item {
    margin-bottom: 25px;
    &__img {
      width: 85px;
      margin-right: 15px;
      min-height: 100px;
      background: #f1f1f1;
      @extend .border-rd-4;

      img {
        @extend .border-rd-4;
      }
    }

    &__publish {
      @extend .display-block;
      margin-bottom: 10px;
    }

    &__body {
      width: calc(100% - 100px);
      min-height: 120px;
      @extend .display-flex;
      @extend .justify-content-between;
      flex-direction: column;
    }
  }
</style>